import { useMemo } from "react";
import TurndownService from "turndown";

const useTurndownService = () => {
  const turndownService = useMemo(() => {
    const service = new TurndownService({ headingStyle: "atx" });
    service.addRule("emptyParagraphToNewline", {
      filter: "br",
      replacement: () => `<br>`, // keep line breaks
    });
    service.keep(["u", "s", "mark"]); // Keep <u>, <s>, and <mark> tags in Markdown

    // Preserve <span style="color: ..."> for text color (can't keep all spans)
    service.addRule("textColorSpan", {
      filter: (node: HTMLElement) =>
        node.nodeName === "SPAN" && /color\s*:/i.test(node.getAttribute("style") || ""),
      replacement: (content: string, node: Node) => {
        const style = (node as HTMLElement).getAttribute("style") || "";
        const match = style.match(/color\s*:\s*([^;]+)/i);
        if (!match) return content;
        return `<span style="color: ${match[1].trim()}">${content}</span>`;
      },
    });

    return service;
  }, []);
  return { turndownService };
};

export default useTurndownService;
